import { create } from 'zustand';
import { IGetAssetMemory, ISetAssetMemory } from '../interfaces';

export class AssetMemoryRepo<T>
  implements IGetAssetMemory<T>, ISetAssetMemory<T>
{
  private assetsMemory: Record<string, T>;

  constructor() {
    this.assetsMemory = {};
  }

  get(id: string): T {
    const asset = this.assetsMemory[id];

    return asset;
  }

  set(id: string, asset: T): void {
    this.assetsMemory[id] = asset;
  }
}

export class AssetMemoryRepoZustend<T>
  implements IGetAssetMemory<T>, ISetAssetMemory<T>
{
  private useAssetMemoryStore = create<Record<string, any>>(() => ({}));

  private getAssetsMemory() {
    return this.useAssetMemoryStore.getState();
  }

  get(id: string): T {
    const asset = this.getAssetsMemory()[id];

    return asset;
  }

  set(id: string, asset: T): void {
    this.useAssetMemoryStore.setState((state) => ({ ...state, [id]: asset }));
  }
}
